import React from "react";
import {Empty} from "antd";
import {useTranslation} from "react-i18next";

export const EmptyMessage = ({descriptionKey = "filters.noDataToList", ns = "common"}) => {
    const {t} = useTranslation([ns]);

    return <Empty description={t(descriptionKey, {ns})} />;
};
